import Catalog from '@components/catalog/Catalog';
import { useAuthenticatedContextProvider } from '@contexts/AuthenticatedContextProvider';

export const CatalogPage = () => {
  const { authenticatedUser, handleLogout } = useAuthenticatedContextProvider();

  return <Catalog userData={authenticatedUser} handleLogout={handleLogout} />;
};

export default CatalogPage;
